import { ColumnType } from "../constants/enums/gridColumnTypeEnum";

interface IColumnDefinition {
  columnType: ColumnType;
  accessorKey: string;
  displayName: string;
  sortingName?: string;
}

/**
 * Generates column definitions from object keys
 * @param data Array of objects to generate columns from
 * @param sorting Optional sorting configuration
 * @param onSortingChange Optional sorting change handler
 * @param excludeKeys Optional array of keys to exclude from columns
 * @returns Array of column definitions
 */
export function generateColumns<T extends object>(
  data: T[],
  sorting?: { column: string; orderBy: string },
  onSortingChange?: (accessor: string) => void,
  excludeKeys: string[] = []
): IColumnDefinition[] {
  if (!data || data.length === 0) {
    return [];
  }

  // Get keys from first object
  const keys = Object.keys(data[0]).filter(key => !excludeKeys.includes(key));

  return keys.filter(e => e !== "").map(key => ({
    columnType: ColumnType.TextHeader,
    accessorKey: key,
    displayName: `${key.toLowerCase()}_label`,
    ...(sorting && onSortingChange && {
      sortingName: key.toLowerCase()
    })
  }));
}